import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Media, MediaItemFragment } from 'src/generated/graphql';
import { MediaPrefix, serveMedia } from 'src/libs/utils';
import { MediaIcon } from './MediaIcon';
import { getURL } from './lib';

const useStyles = makeStyles({
    background: {
        backgroundImage: ({ url }: { url: string }) => `url(${url})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        width: '100%',
        height: '100%',
    },
});

type MediaItemProps = {
    className?: string;
    item: MediaItemFragment;
    showIcon?: boolean;
    onClick?: (item: Media) => void;
    imageSize?: MediaPrefix;
    background?: boolean
}

export const MediaItem = ({
    item,
    onClick,
    className,
    showIcon = false,
    imageSize,
    background = false
}: MediaItemProps) => {
    const url = serveMedia(item.location, imageSize);
    const classes = useStyles({ url });
    const link = getURL(item.location);

    const clickHandler = () => {
        if (onClick) {
            onClick(item);
        }
    };

    if (!item.location) {
        return <div />;
    }

    if (showIcon && item.mimetype) {
        return <MediaIcon mimetype={item.mimetype} className={className} />;
    }

    if (item.type === 'pdf') {
        return (
            <Box width="100%" height="100%" onClick={clickHandler}>
                <iframe
                    src={`${serveMedia(item.location, imageSize)}#toolbar=0&navpanes=0&scrollbar=0`}
                    title={item.title || ''}
                    className={className}
                />
            </Box>
        );
    }

    if (item.type === 'tour') {
        return (
            <iframe src={link} title="Virtual Tour" className={className} />
        );
    }

    if (background) {
        return <div className={classes.background} />;
    }

    return (
        /* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */
        <img
            src={serveMedia(item.location, imageSize)}
            alt={item.title || ''}
            onClick={clickHandler}
            style={{ maxWidth: '100%', maxHeight: '620px' }}
            className={className}
        />
    );
};
